import { createAction } from 'redux-actions';
import {
  SEARCH_REQUEST,
  SEARCH_SUCCESS,
  SEARCH_FAILURE,
  SEARCH_BY_TYPE_REQUEST,
  SEARCH_BY_TYPE_SUCCESS,
  SEARCH_BY_TYPE_FAILURE,
  CLEAR_SEARCH,
  SEARCH_VALUE_BY_TYPE_REQUEST,
  SEARCH_VALUE_BY_TYPE_SUCCESS,
  SEARCH_VALUE_BY_TYPE_FAILURE,
  SEARCH_RELATIONS_REQUEST,
  SEARCH_RELATIONS_SUCCESS,
  SEARCH_RELATIONS_FAILURE,
  CLEAR_SEARCH_RESULT,
  SEARCH_FILTERS_REQUEST,
  SEARCH_FILTERS_REQUEST_SUCCESS,
  SEARCH_FILTERS_REQUEST_FAILURE,
  SHOULD_REFETCH,
} from './constants';

export const search = createAction(SEARCH_REQUEST);
export const searchSuccess = createAction(SEARCH_SUCCESS);
export const searchFailure = createAction(SEARCH_FAILURE);

export const searchByType = createAction(SEARCH_BY_TYPE_REQUEST);
export const searchByTypeSuccess = createAction(SEARCH_BY_TYPE_SUCCESS);
export const searchByTypeFailure = createAction(SEARCH_BY_TYPE_FAILURE);

export const searchValueByType = createAction(SEARCH_VALUE_BY_TYPE_REQUEST);
export const searchValueByTypeSuccess = createAction(SEARCH_VALUE_BY_TYPE_SUCCESS);
export const searchValueByTypeFailure = createAction(SEARCH_VALUE_BY_TYPE_FAILURE);

export const searchRelations = createAction(SEARCH_RELATIONS_REQUEST);
export const searchRelationsSuccess = createAction(SEARCH_RELATIONS_SUCCESS);
export const searchRelationsFailure = createAction(SEARCH_RELATIONS_FAILURE);

export const clearSearch = createAction(CLEAR_SEARCH);

export const clearSearchResult = createAction(CLEAR_SEARCH_RESULT);

export const getSearchFilters = createAction(SEARCH_FILTERS_REQUEST);
export const getSearchFiltersSuccess = createAction(SEARCH_FILTERS_REQUEST_SUCCESS);
export const getSearchFiltersFailure = createAction(SEARCH_FILTERS_REQUEST_FAILURE);

export const shouldRefetch = createAction(SHOULD_REFETCH);
